export class CarModel {
  constructor(id, name, carMakeId) {
    this.id = id;
    this.name = name;
    this.carMakeId = carMakeId;
  }

  // set carModels from response array
  static setCarModels(carModels) {
    return carModels.map(
      (carModel) =>
        new CarModel(carModel.id, carModel.name, carModel.car_make_id)
    );
  }
}
